<template>
    <div>
        <tab name="10">{{id}} {{activityName}}</tab>
        <div class="page-group-title"><span>变动明细</span></div>
        <div class="page-list-box" v-loading="dataLoading">
            <el-table
                :data="updateList"
                border
                style="width: 100%"
                tooltip-effect="dark"
                ref="updateList"
                size="small"
                @selection-change="selectionChange"
            >
                <el-table-column type="selection" :selectable="(row) => row.status === 1" width="55"></el-table-column>
                <el-table-column prop="ticketName" width="80" label="操作">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/activityUpdateRecord/ignore') && scope.row.status === 1"
                            type="text"
                            size="small"
                            @click="onIgnore(scope.row.id)"
                            >忽略</el-button
                        >
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status === 1">待处理</p>
                        <p v-else-if="scope.row.status === 2">已通知</p>
                        <p v-else-if="scope.row.status === 3">忽略</p>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="变动时间"></el-table-column>
                <el-table-column prop="activitySessionName" label="所属场次"></el-table-column>
                <el-table-column label="变动类型">
                    <template slot-scope="scope">
                        <p v-if="scope.row.type === 1">开演时间变动</p>
                        <p v-else-if="scope.row.type === 2">场地变动</p>
                        <p v-else-if="scope.row.type === 3">艺人变动</p>
                        <p v-else-if="scope.row.type === 4">取票日期变动</p>
                        <p v-else-if="scope.row.type === 5">取票时间变动</p>
                        <p v-else-if="scope.row.type === 6">取票地点变动</p>
                        <p v-else-if="scope.row.type === 7">取票说明变动</p>
                        <p v-else-if="scope.row.type === 8">通票绑定场次变动</p>
                        <p v-else-if="scope.row.type === 9">通票场次取消</p>
                        <p v-else-if="scope.row.type === 10">赠票绑定场次变动</p>
                        <p v-else-if="scope.row.type === 11">演出延期</p>
                    </template>
                </el-table-column>
                <el-table-column prop="subContent" label="变动内容" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createUserName" label="修改人"></el-table-column>
            </el-table>
        </div>
        <div class="page-btns-box">
            <el-button type="primary" :loading="btnLoading" v-if="$utils.have('/activityUpdateRecord/send')" @click="checkDetailSend" :disabled="selection.length <= 0" icon="el-icon-s-promotion" size="small">发送通知</el-button>
        </div>
        <div class="page-group-title"><span>通知记录</span></div>
        <div class="page-list-box" v-loading="dataLoading">
            <el-table
                :data="sendList"
                border
                style="width: 100%"
                size="small"
            >
                <el-table-column type="expand" label="展开">
                    <template slot-scope="props">
                        实际变更项：
                        <div class="MT10" v-html="props.row.subContent"></div>
                    </template>
                </el-table-column>   
                <el-table-column prop="createTime" label="通知时间"></el-table-column>
                <el-table-column prop="refundEndTime" label="退票截止时间"></el-table-column>
                <el-table-column prop="content" label="最终通知内容" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createUserName" label="修改人"></el-table-column>
            </el-table>
        </div>
        <div class="page-btns-box">
            <el-button @click="goBack">返回</el-button>
        </div>
        <add :visible.sync="visible" :detail="detail" :id="id" @onRefresh="fetch"></add>
    </div>
</template>

<script>
import Tab from '../components/tab';
import Add from './components/add';

export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    components:{
        Tab,
        Add
    },
    data(){
        return{
            visible: false,
            dataLoading:false,
            btnLoading: false,
            data: null,
            sendList: [],
            updateList: [],
            selection: [],
            detail: {},
            activityName: '',
            redirect: this.$route.query.redirect,
        }
    },
    mounted(){
        this.fetch();
    },
    methods:{
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
        async checkDetailSend () {
            this.btnLoading = true;
            const response = await this.$request({
                url: "/activityUpdateRecord/checkDetailSend",
                method: "POST",
                params: {activityId: this.id, ids: this.selection.map(row => row.id).toString()},
            })
            const {state, msg, result} = response.data;
            this.btnLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.detail = result;
            this.visible = true;
        },
        selectionChange (selection) {
            this.selection = selection;
        },
        onIgnore (id) {
            this.$confirm('是否确认忽略该项改动？', '改动操作', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(async () => {
                const response = await this.$request({
                    url: "/activityUpdateRecord/ignore",
                    method: "POST",
                    params: {id},
                });
                const {msg, state} = response.data;
                if (state != 1) return this.$message.error(msg);
                this.$message.success('改动操作成功');
                this.fetch();
            })
        },
        async fetch() {
            this.fetchLoading = true;
            const response = await this.$request({
                url: "/activityUpdateRecord/list",
                method: "POST",
                params: {activityId: this.id},
            })
            const {state, msg, result} = response.data;
            this.fetchLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.sendList = result.sendList || [];
            this.sendList.map(item => {
                item.subContent = item.subContent && item.subContent.replaceAll(';','<br>') || "";
            })
            this.updateList = result.updateList;
            this.activityName = result.activityName;
        },
    }
}
</script>